import React from 'react'
import { isEmpty, omit } from 'ramda'
import { isEmptyOrNil } from 'libs/empty'

export const VirtualTableContext = React.createContext({
  header: <></>,
})

export const loaderRow = (pagination) => {
  return pagination.perPage ?? 10
}
export const loaderColumns = (isCheckbox, columnsCount) => {
  return isCheckbox ? columnsCount + 1 : columnsCount
}

export const propsTableCell = (props) => {
  return omit(['sort', 'render', 'action', 'disabled'], props)
}

export const isCheckAll = (data, currentCount, isLoading) => {
  return !isEmpty(data) && !isLoading && currentCount === data.length
}

export const isIndeterminate = (currentCount, dataCount) => {
  return currentCount > 0 && currentCount !== dataCount
}

export const handleData = (data) => {
  return isEmptyOrNil(data) ? '--' : data
}
